import {
  branch,
  compose,
  renderNothing,
  setDisplayName,
  setPropTypes
} from 'recompose'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'

const ifHomePreview = compose(
  setDisplayName('ifHomePreview'),
  withRouter,
  setPropTypes({
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired
    }).isRequired
  }),
  branch(
    ({ location }) => !location.pathname.includes('/preview/home'),
    renderNothing
  )
)

export default ifHomePreview
